import { defineMessages } from 'react-intl';

export default defineMessages({
    vendorsInvolved: {
        id: 'portal.claim.views.claim-detail.claim.views.claim-detail.Vendors involved',
        defaultMessage: 'Vendors involved'
    }
});
